import { shrpaApi } from "./axios";

// Types
import { CustomCollabClientPayload, CustomCollabCreatorData, CustomCollabCustomerData, CustomCollabWidgetPayload } from "@contracts/customCollabs";

export default {
  async getAllCustomCollabsV2(creatorId: string, impersonatedUserCreatorId: string | null = null): Promise<Array<CustomCollabWidgetPayload>> {
    // Add impersonatedUserCreatorId to query params if it exists
    const queryParams: Record<string, string> = {};
    if (impersonatedUserCreatorId) {
      queryParams.impersonatedUserCreatorId = impersonatedUserCreatorId;
    }

    const queryString = Object.keys(queryParams).length > 0 ? `?${new URLSearchParams(queryParams).toString()}` : "";
    const uri = `/creator/${creatorId}/custom-collabs/v2${queryString}`;

    const { data } = await shrpaApi.get<Array<CustomCollabWidgetPayload>>(uri);
    return data;
  },

  async getCustomCollab(creatorId: string, customerId: string, customCollabId: string): Promise<CustomCollabClientPayload> {
    const uri = `/creator/${creatorId}/custom-collabs/${customerId}/${customCollabId}`;

    const { data } = await shrpaApi.get<CustomCollabClientPayload>(uri);
    return data;
  },

  async saveCustomCollab(creatorId: string, customerId: string, customCollabId: string, customCollabCreatorData: CustomCollabCreatorData, isImpersonating = false): Promise<CustomCollabClientPayload> {
    // If impersonating, add the impersonate to the querystring
    const queryParams = isImpersonating ? { impersonate: "true" } : {};
    const uri = `/creator/${creatorId}/custom-collabs/${customerId}/${customCollabId}?${new URLSearchParams(queryParams).toString()}`;
    const config = { headers: { "Content-Type": "application/json" } };
    const payload = JSON.stringify(customCollabCreatorData);

    const { data } = await shrpaApi.put<CustomCollabClientPayload>(uri, payload, config);
    return data;
  },

  async agreeToCollabDetails(creatorId: string, customerId: string, customCollabId: string): Promise<CustomCollabClientPayload> {
    const uri = `/creator/${creatorId}/custom-collabs/${customerId}/${customCollabId}/formally-agree`;
    const { data } = await shrpaApi.post<CustomCollabClientPayload>(uri);
    return data;
  },

  async markDeliverablesReady(creatorId: string, customerId: string, customCollabId: string): Promise<CustomCollabClientPayload> {
    const uri = `/creator/${creatorId}/custom-collabs/${customerId}/${customCollabId}/deliverables-ready`;
    const { data } = await shrpaApi.post<CustomCollabClientPayload>(uri);
    return data;
  },

  async loadCustomerCollabInputsSnapshot(creatorId: string, customerId: string, customCollabId: string): Promise<CustomCollabCustomerData> {
    const uri = `/creator/${creatorId}/custom-collabs/${customerId}/${customCollabId}/snapshot`;
    const { data } = await shrpaApi.get<CustomCollabCustomerData>(uri);
    return data;
  },
};
